import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';

import { FileSetDto } from 'api';
import { DeleteRefreshFunction } from 'library/components/controls/files/UnitFileRemoveButton';
import { SectionTitle } from 'library/components/controls/layout/SectionTitle';
import { FileSetDisplay } from 'modules/Shared/Components/FileUpload/FileSetDisplay';

export const AdditionalFilesSection = ({
	fileSets,
	additionalAction,
	onDelete,
}: {
	fileSets: FileSetDto[];
	additionalAction?: React.ReactNode;
} & DeleteRefreshFunction): React.JSX.Element => {
	const { t } = useTranslation(['unitOverview', 'fileUpload']);

	return (
		<>
			<SectionTitle
				title={t('unitOverview:additional-files-title')}
				titleVariant="h6">
				{additionalAction}
			</SectionTitle>
			<Box
				sx={{
					display: 'grid',
					gap: 3,
				}}>
				{fileSets?.map((fileSet) => (
					<Paper key={fileSet.id} variant="bottomBorder">
						<FileSetDisplay {...fileSet} onDelete={onDelete} />
					</Paper>
				))}
			</Box>
		</>
	);
};
